import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { GlobalService } from 'app/global.service';
import { NavigationEnd, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { filter, Observable, Subject, Subscription, takeUntil } from 'rxjs';
import { FuseNavigationItem } from '@fuse/types';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { Dialog } from '@angular/cdk/dialog';
import { SettingsPageComponent } from 'app/main/components/settings-page/settings-page.component';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-bottom-navbar',
  imports: [
    MatToolbarModule,
    MatIconModule,
    CommonModule,
    FlexLayoutModule,
    TranslocoModule
  ],
  standalone: true,
  templateUrl: './bottom-navbar.component.html',
  styleUrl: './bottom-navbar.component.scss'
})
export class BottomNavbarComponent implements OnInit, OnDestroy {

  navigation: any[];
  private _unsubscribeAll: Subject<any> = new Subject();;
  navigation$ : Observable<FuseNavigationItem[]>
  private _routerSubscription: Subscription;
  private activeLanguage: string;

   constructor(
      private _globalService : GlobalService,
      private _router: Router,
          private dialog: Dialog,
      private translocoService: TranslocoService,

    ){}

  ngOnInit(): void {
    this.navigation$ = this._globalService.currentBottomNavigation;
    this.navigation = this._globalService.getBottomNavigation();
    this.activeLanguage = this.translocoService.getActiveLang();
    this.translocoService.langChanges$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(lang => this.activeLanguage = lang);
    // Subscribe to router events to detect URL changes
    this._router.events
      .pipe(takeUntil(this._unsubscribeAll),filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        // This will trigger change detection and update active classes
      });
  }

  getBottomNavLabel(title: string): string {
    if (this.activeLanguage === 'tn') {
      return this.translocoService.translate(`navbar.mobile_${title}`);
    }

    return this.translocoService.translate(`navbar.${title}`);
  }

  /**
   * Navigate to the specified URL
   * or open a dialog
   * @param url The URL to navigate to
   */
  decideRouteOrDialog(url: string): void {
    if (url) {
      this.navigateTo(url);
    } else {
      // open a dialog
      this.openSettingsPage();
    }
  }

   /**
   * Navigate to the specified URL
   * @param url The URL to navigate to
   */
  navigateTo(url: string): void {
    this._router.navigate([url]);
  }

  openSettingsPage(){
    this._router.navigate(['/settings'])
      // this.dialog.open(SettingsPageComponent,{
      //   minWidth: "100%",
      //   minHeight: "100%",
      // }) 
  }

  /**
   * Check if the route is currently active
   * @param url The URL to check
   * @returns True if the current URL starts with the given URL
   */
  isRouteActive(url: string): boolean {
    if (!url) {
      if (this._router.url == "/settings") {
        return true;
      }
      return false;
    }
    
    // Get the current URL without query parameters
    const currentUrl = this._router.url.split('?')[0];
    // Check if the current URL starts with the given URL
    return currentUrl === url || (url !== '/' && currentUrl.startsWith(url));
  }

  ngOnDestroy(): void {
    // Clean up subscription when component is destroyed
      this._unsubscribeAll.next(true);
      this._unsubscribeAll.complete();
  }
}
